import React, { Component } from 'react';
import Table from '../components/indicators/CategoryIndicator/Index'
import WebpackerReact from 'webpacker-react';

class CategoryIndicatorsIndex extends Component {
    constructor(props) {
        super(props);
        this.token = document.querySelector("[name='csrf-token']").content;
        this.state = {
            data: [],
            isLoaded: true,

            //pagination 

            activePage: 1,
            countPage: 12,
            total: 0
        }
    }

    componentDidMount(){
        this.loadData();
    }

    updateStateLoad = (state) => {
        this.setState({ isLoaded: state })
    } 

    //add items
    updateData = (data) => {
        this.setState({
            data: [...this.state.data, data],
        })
    }

    //add update
    updateItem = format => {
        this.setState({
            data: this.state.data.map(item => {
            if (format.id === item.id) {
              return { ...item, 
                name: format.name,
                section_name: format.section_name,
                order_number: format.order_number,
                positions: format.positions
              }
            }
            return item;
          })
        });
    }

    loadData = () => {
        fetch(`/indicator/get_category_indicators`, {
            method: 'GET', // or 'PUT'
            headers: {
                "X-CSRF-Token": this.token,
                "Content-Type": "application/json"
            }
        })
        .then(response => response.json())
        .then(data => {

            this.setState({
                data: data.data,
                total: data.total,
                isLoaded: false
            });
        });
    }

    handlePageChange = pageNumber => {
        this.setState({ activePage: pageNumber }); 
        fetch(`/indicator/get_category_indicators?page=${pageNumber}&filter=${this.state.countPage}&filtering=${this.state.filtering}`, {
            method: 'GET', // or 'PUT'
            headers: {
                "X-CSRF-Token": this.token,
                "Content-Type": "application/json"
            }
        })
        .then(response => response.json())
        .then(data => {
            this.setState({ 
                data: data.data,
                total: data.total,
            });
        });     
    };  


    render() {
        return (
            <React.Fragment>
                <Table
                    updateStateLoad={this.updateStateLoad}
                    loadData={this.loadData}
                    data={this.state.data}
                    isLoaded={this.state.isLoaded}
                    updateItem={this.updateItem}
                    updateData={this.updateData}
                    estados={this.props.estados}

                    users={this.props.users}
                    positions={this.props.positions}
                    formatos={this.props.formatos}
                    current_url={this.props.current_url}
                    task_board_templates={this.props.task_board_templates}

                    //pagination
                    totalData={this.state.total}
                    activePage={this.state.activePage}
                    countPage={this.state.countPage}
                    handlePageChange={this.handlePageChange}
                />
            </React.Fragment>
        );
    }
}


export default CategoryIndicatorsIndex;
WebpackerReact.setup({ CategoryIndicatorsIndex });
